import { render, staticRenderFns } from "./PrestationReference.vue?vue&type=template&id=3dc9debc"
import script from "./PrestationReference.vue?vue&type=script&lang=js"
export * from "./PrestationReference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports